<template>
  <div v-editable="faq" class="relative px-[30px] py-[12px] bg-white mb-[17px] shadow" :class="{'rounded-full': !opened, 'rounded-[40px]': opened}">
    <div class="absolute w-full h-full opacity-30 bg-[#2699C6] z-[-1]" style="filter: blur(250px);"></div>
    <button
      class="hidden md:flex font-semibold text-left items-center transition-all duration-200 group hover:opacity-80 focus:outline-none text-body"
      :class="{ 'text-brand-blue': !opened, 'text-brand-orange': opened }"
      @click="opened = !opened"

    >
      <div>
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"
             class="mr-3 transition-all duration-150 transform outline-none group-hover:scale-110"
             :class="{
        'text-brand-blue': !opened,
        'text-brand-orange rotate-45': opened,
      }"
        >
          <g id="Icon" clip-path="url(#clip0_4255_11527)">
            <path id="Vector"
                  d="M6.22327 19.2305C6.22327 20.1896 7.00081 20.9672 7.95998 20.9672L16.7653 20.9671L16.7654 29.7726C16.7653 30.7317 17.5429 31.5093 18.502 31.5092C19.4612 31.5092 20.2387 30.7317 20.2387 29.7725L20.2386 20.9671L29.0441 20.9672C30.0032 20.9672 30.7808 20.1896 30.7808 19.2305C30.7808 18.2714 30.0032 17.4938 29.0441 17.4938L20.2386 17.4938L20.2388 8.68841C20.2387 7.7293 19.4612 6.95174 18.5021 6.95172C17.5428 6.9518 16.7653 7.72927 16.7654 8.6884L16.7653 17.4938L7.95997 17.4938C7.00082 17.4938 6.22327 18.2713 6.22327 19.2305Z"
                  fill="#2699C6"/>
          </g>
          <defs>
            <clipPath id="clip0_4255_11527">
              <rect width="35.3189" height="35.3189" fill="white" transform="translate(0.5 0.671875)"/>
            </clipPath>
          </defs>
        </svg>

      </div>
      <span class="text-left items-center flex text-black font-medium md:text-[26px] text-[16px]"
            v-html="faq.q" style="line-height: normal;"></span>
    </button>
    <button
      class="flex md:hidden font-semibold text-left transition-all duration-200 group hover:opacity-80 focus:outline-none text-body"
      :class="{ 'text-brand-blue': !opened, 'text-brand-orange': opened }"
      @click="opened = !opened"

    >
      <div>
        <svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"
             class="mr-3 transition-all duration-150 transform outline-none group-hover:scale-110"
             :class="{
        'text-brand-blue': !opened,
        'text-brand-orange rotate-45': opened,
      }"
        >
          <g id="Icon" clip-path="url(#clip0_4255_11527)">
            <path id="Vector"
                  d="M6.22327 19.2305C6.22327 20.1896 7.00081 20.9672 7.95998 20.9672L16.7653 20.9671L16.7654 29.7726C16.7653 30.7317 17.5429 31.5093 18.502 31.5092C19.4612 31.5092 20.2387 30.7317 20.2387 29.7725L20.2386 20.9671L29.0441 20.9672C30.0032 20.9672 30.7808 20.1896 30.7808 19.2305C30.7808 18.2714 30.0032 17.4938 29.0441 17.4938L20.2386 17.4938L20.2388 8.68841C20.2387 7.7293 19.4612 6.95174 18.5021 6.95172C17.5428 6.9518 16.7653 7.72927 16.7654 8.6884L16.7653 17.4938L7.95997 17.4938C7.00082 17.4938 6.22327 18.2713 6.22327 19.2305Z"
                  fill="#2699C6"/>
          </g>
          <defs>
            <clipPath id="clip0_4255_11527">
              <rect width="35.3189" height="35.3189" fill="white" transform="translate(0.5 0.671875)"/>
            </clipPath>
          </defs>
        </svg>

      </div>
      <span class="text-left flex items-center text-black font-medium md:text-[26px] text-[16px]" v-html="faq.q"></span>
    </button>

    <transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="transform -translate-y-3 opacity-0"
      enter-to-class="transform opacity-100"
      leave-active-class="transition duration-300 ease-in"
      leave-from-class="transform opacity-100"
      leave-to-class="transform -translate-y-3 opacity-50"
    >
      <p class="mt-3 md:ml-12 ml-9" v-if="opened" v-html="faq.a">

      </p>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    faq: Object,
  },

  data() {
    return {
      opened: false,
    };
  },
};
</script>

<style>
</style>
